var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgListings = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0433 2.50314L7.14389 8.87631C6.71412 9.56813 7.21726 10.4696 8.03487 10.4696H15.8231C16.6407 10.4696 17.1439 9.56813 16.7141 8.87631L12.8252 2.50314C12.4164 1.83229 11.4521 1.83229 11.0433 2.50314Z",
    fill: "#6D675F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6994 22C20.3045 22 22.4164 19.8881 22.4164 17.283C22.4164 14.6779 20.3045 12.566 17.6994 12.566C15.0943 12.566 12.9824 14.6779 12.9824 17.283C12.9824 19.8881 15.0943 22 17.6994 22Z",
    fill: "#6D675F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54822 21.4758H9.83753C10.414 21.4758 10.8857 21.0041 10.8857 20.4276V14.1383C10.8857 13.5618 10.414 13.0901 9.83753 13.0901H3.54822C2.9717 13.0901 2.5 13.5618 2.5 14.1383V20.4276C2.5 21.0041 2.9717 21.4758 3.54822 21.4758Z",
    fill: "#6D675F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgListings, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/listings.642a0bad.svg";
export { ForwardRef as ReactComponent };